import { cpOrderFormApiConnector } from 'apiConnector/secondary-market/cp-order/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import {
  secondaryMarketDominoSettlementDateFetchFailed,
  secondaryMarketDominoSettlementDateReceived,
} from 'state/secondaryMarket/cpOrder/referential/referential.actions';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';
import { extractHttpErrorMessage } from 'utils/http/httpClient.model';

import { getTabRemoved$ } from '../utils';

export function loadNewSettlementDateEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { getSettlementDate } = cpOrderFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_DOMINO_SETTLEMENT_DATE_REQUESTED'),
      mergeMap(({ valuationDate, tabId, bcsProductKey, cobDate, tradeDateType, counterpartyEliotId, clientType }) => {
        return getSettlementDate(
          bcsProductKey,
          valuationDate!,
          cobDate,
          tradeDateType,
          counterpartyEliotId,
          clientType,
        ).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(data =>
            secondaryMarketDominoSettlementDateReceived(tabId, data.settlementDate, data.firstSettlementDate),
          ),
          catchError((err: HttpError) => {
            return of(
              secondaryMarketDominoSettlementDateFetchFailed(
                tabId,
                bcsProductKey,
                extractHttpErrorMessage(err, { backend: 'domino' })!,
              ),
            );
          }),
        );
      }),
    );
  };
}
